import { TippyV2 } from "@circle-react/components/shared/TippyV2";
import { StatusIconContent } from "./StatusIconContent";

interface StatusIconProps {
  hasError?: boolean;
  hasSuccess?: boolean;
  statusMessage?: string;
}

export const StatusIcon = ({
  hasError = false,
  hasSuccess = false,
  statusMessage,
}: StatusIconProps) => {
  if (!hasError && !hasSuccess) {
    return null;
  }

  if (statusMessage) {
    return (
      <TippyV2 content={statusMessage} className="cursor-pointer">
        <StatusIconContent hasError={hasError} />
      </TippyV2>
    );
  }

  return <StatusIconContent hasError={hasError} />;
};
